import type { ILabelGroupTemplate3MaxLabels6Props } from 'blocks/LabelGroup/Templates'
import type { ITVShowPopupProps } from 'blocks/Popup/Templates'
import type { IMultiColumnsItemProps } from '../../MultiColumnsItem'

import { TextBoxMaxLine3Body3 } from 'atoms/TextBox/Templates'
import { TextBlockWithMore } from 'blocks/TextBlock/Templates'
import { MultiColumnsRowGap } from '../../MultiColumns.h'
import { MultiColumnsItem } from '../../MultiColumnsItem'

export interface IMCItemWithMore extends Omit<
  IMultiColumnsItemProps,
  'children'
> {
  labels?: ILabelGroupTemplate3MaxLabels6Props['list']
  text: string
  more?: boolean
  textStars?: string
  textDirectors?: string
  episodePopup?: ITVShowPopupProps['title']
  titlePopup?: ITVShowPopupProps['description']
  labelsPopup?: ITVShowPopupProps['labels']
  listPopup?: ITVShowPopupProps['list']
  directorsPopup?: ITVShowPopupProps['directors']
  starsPopup?: ITVShowPopupProps['stars']
  titleButton?: string
  fullInformation?: boolean
  popupWidth?: string
  withUsingPortal?: boolean
  directors?: string
  stars?: string
  maxLineMore?: number
  textInBanner?: boolean
  maxLineDirectors?: number
  maxLineStars?: number
  onClickMore?: (args: any) => void
  directorsTitle?: string
  starsTitle?: string
}

export const MCItemWithMore = ({
  text,
  rowGap = MultiColumnsRowGap.INDENT_20,
  more = true,
  textDirectors = '',
  textStars = '',
  episodePopup: _unused1,
  titlePopup: _unused2,
  labelsPopup: _unused3,
  listPopup: _unused4,
  titleButton,
  fullInformation,
  popupWidth: _unused5,
  withUsingPortal: _unused6,
  starsPopup: _unused7,
  directorsPopup: _unused8,
  directors: _unused9,
  stars: _unused10,
  maxLineMore = 2,
  textInBanner = true,
  maxLineDirectors = 1,
  maxLineStars = 1,
  onClickMore,
  directorsTitle,
  starsTitle,
  ...rest
}: IMCItemWithMore) => {
  return (
    <MultiColumnsItem rowGap={rowGap} {...rest}>
      {more && (
        <TextBlockWithMore
          description={text}
          stars={textStars}
          directors={textDirectors}
          titleButton={titleButton}
          fullInformation={fullInformation}
          maxLines={maxLineMore}
          textInBanner={textInBanner}
          maxLineDirectors={maxLineDirectors}
          maxLineStars={maxLineStars}
          onClickMore={onClickMore}
          directorsTitle={directorsTitle}
          starsTitle={starsTitle}
        />
      )}
      {text && !more && (
        <TextBoxMaxLine3Body3 preWrap>{text}</TextBoxMaxLine3Body3>
      )}
    </MultiColumnsItem>
  )
}
